<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Senarai Perumahan">

             <w-flex justify-space-between class="mb4">
                
                <div class="xs4"> 
                    <w-input v-model="cari.no_skim" required label="No. Skim Perumahan" /> 
                </div>
                <div class="xs4"> 
                    <w-input v-model="cari.profil_nama" required label="Nama / No Id" /> 
                </div>

                <div class="xs4"> 
                    <w-input v-model="cari.no_rumah" required label="No Rumah" /> 
                </div>
                
            </w-flex>
            <w-flex justify-space-between class="mb4">
                 <div class="xs4"> 
                    <z-lookup
                            label="Status Premis"
                            name="status"
                            :url="service_tunggakan + 'lookup/perumahan_premis'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_perumahan_premis_id"
                        />
                </div>
                <div class="xs4">
                   <w-input v-model="cari.tarikh_mula_duduki" required label="Tarikh Mula Menduduki" type="date"/>  
                </div>
                <div class="xs4">
                    <w-input v-model="cari.tarikh_tamat_duduki" required label="Tarikh Akhir Menduduki" type="date"/> 
                </div>
               
            </w-flex>
            <w-flex justify-space-between class="mb4">
                 <div class="xs4"> 
                    <z-lookup
                            label="Status "
                            name="status"
                            :url="service_tunggakan + 'lookup/status_perumahan'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_perumahan_status_id"
                        />
                </div>
                <div class="xs4"> 
                    <w-input v-model="cari.kod_premis" required label="Kod Premis" /> 
                </div>
                <div class="xs4">
                    <w-input v-model="cari.no_akaun" required label="No Akaun" /> 
                </div>
               
            </w-flex>
            <div class="mt2 text-right">
                <w-button class="ml1" v-on:click="reset()" bg-color="warning" :loading="cari.loading">
                    <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="search()" :loading="cari.loading">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
            </div>
            <br>

            <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>
            <center v-if="cari.loading"><w-progress class="ma1" circle></w-progress></center>   

           
            <z-table ref="tbluser" title="Senarai Perumahan" :headers="table.headers" :items="table.items" :meta="table.meta" class="">

               <template #item-cell.no_skim="{ item, label, header, index }">
                             <div>{{item.lkp_perumahan_keterangan}} | {{item.no_skim}} </div> 
                </template>
                
                 <template #item-cell.alamat="{ item, label, header, index }">
                             <div>{{item.no_rumah}} | {{item.alamat}} </div> 
                </template>
                
                 <template #item-cell.jumlah_kutipan_sewa="{ item, label, header, index }">
                             <div class="text-right">{{$zutil.currency(item.jumlah_kutipan_sewa)}}</div> 
                </template>
                
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                           <inertia-link :href='$route("perumahan.show",item.id)'>
                            <w-tooltip top>
                               <template #activator="{ on }">
                                 <w-icon v-on="on" >
                                   fal fa-file
                                 </w-icon>
                               </template>
                               Papar
                             </w-tooltip>
                            </inertia-link>
                    </w-flex>
                </template>
            </z-table>
            
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
            resourceurl: this.service_tunggakan + "perumahan",
        reload: true,
        loading: true,
        cari : {
            loading: false,
        },
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Perumahan', route: '/perumahan' },
            { label: 'Senarai', route: '/perumahan' }
          ],
           cari : {no_skim: '', profil_nama:'' , no_rumah:'' ,lkp_perumahan_premis_id:'', tarikh_mula_duduki:'', tarikh_tamat_duduki:'', lkp_perumahan_status_id:'', kod_premis:'', no_akaun:''}
        }
         
  },
  methods: {

         search() {
            this.cari.loading = true
             this.$inertia.visit(window.route('perumahan.index')+'?no_skim='+this.cari.no_skim+'&profil_nama='+this.cari.profil_nama+'&no_rumah='+this.cari.no_rumah+'&lkp_perumahan_premis_id='+this.cari.lkp_perumahan_premis_id+'&tarikh_mula_duduki='+this.cari.tarikh_mula_duduki+'&tarikh_tamat_duduki='+this.cari.tarikh_tamat_duduki+'&lkp_perumahan_status_id='+this.cari.lkp_perumahan_status_id+'&kod_premis='+this.cari.kod_premis+'&no_akaun='+this.cari.no_akaun , {preserveScroll:true})
            
        },
        reset(){
              this.cari = {no_skim: '', profil_nama:'' , no_rumah:'' ,lkp_perumahan_premis_id:'', tarikh_mula_duduki:'', tarikh_tamat_duduki:'', lkp_perumahan_status_id:'', kod_premis:'', no_akaun:''}
              this.search()
        },
        // load() {
        //     // this.loading = true
        //     this.$zcomm.get(this.service_tunggakan+'perumahan'+window.location.search)
        //     .then(res => {
        //       })
        //     .finally(() => {

        //         this.loading = false
        //         });
        // },
  },
  watch: {
    
  },
  mounted() {
    // this.load();
    // override default setting
    this.dialog.width = 900
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>